import axios from "axios";
import { store as storeNotification } from "react-notifications-component";
import {
	USER_STATUS_FAILED,
	USER_STATUS_INITIALIZE,
	USER_STATUS_SAVED,
	USER_STATUS_SAVING,
} from "./types";
export const saveUserStatus = (listdata) => (dispatch) => {
	dispatch({ type: USER_STATUS_SAVING });

	let formData = new FormData(); //formdata object
	console.log("imageUploadActions input data=", listdata);

	listdata.data.map((listdata) => {
		formData.append(listdata.name, listdata.value); //append the values with key, value pair
		console.log("saveUserStatus listdata.value=", listdata.value);
	});
	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};

	axios
		.post(
			listdata.url,
			{ status: listdata.data[0].value, username: listdata.data[1].value },
			config
		)
		.then((response) => {
			console.log("saveUserStatus response=", response);
			if (response.data.success) {
				storeNotification.addNotification({
					title: "Status!",
					message: "New Status Saved",
					type: "success",
					insert: "top",
					container: "top-right",
					animationIn: ["animated", "fadeIn"],
					animationOut: ["animated", "fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
				return dispatch({
					type: USER_STATUS_SAVED,
					payload: {
						status: response.data.message,
						image: response.data.image,
					},
				});
			} else {
				return dispatch({
					type: USER_STATUS_FAILED,
					payload: response.data.message,
				});
			}
		})
		.catch((error) => {
			console.log("saveUserStatus error=", error);
		});
};

export const initializeUserStatus = (data) => (dispatch) => {
	dispatch({
		type: USER_STATUS_INITIALIZE,
		payload: data,
	});
};
